import styled from 'styled-components'

export const ChildrenContainer = styled.div`
  padding: 0.1rem 0.1rem;
  border: 2.5px solid;
  border-radius: 0px 4px 4px;
`

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const BuyersContainer = styled.div``

export const Badge = styled.div`
  border-radius: 4px 4px 0px 0px;
  padding: 2px 8px 0px;
  width: max-content;
`

export const BadgeText = styled.span`
  font-family: Work Sans;
  font-weight: bold;
  font-size: 14px;
`
